import Payee from "./Payee";

export default Payee;
